export enum StandardValidationConstraintKeys {
    MIN = 'MIN',
    MAX = 'MAX',
    MIN_LENGTH = 'MIN_LENGTH',
    MAX_LENGTH = 'MAX_LENGTH',
    REQUIRED = 'REQUIRED',
    PATTERN = 'PATTERN',
    VALID_NUMBER = 'VALID_NUMBER',
}
